// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"50":"d15b2afc","91":"cd434053","125":"6100528f","222":"2ddbad97","234":"9b74bc8d","372":"aff6af77","387":"aa11f5d0","407":"e082eaa5","410":"2ec93b7a","462":"5cca8742","520":"ab90e93c","639":"44602038","736":"2c7a2162"}[chunkId] + ".js";
};